import { BaseFilterParameter, IBaseFilterParameter } from "../base-filter.parameter";
import { IBaseModel, BaseModel } from "../base.model";

export interface IDocumentTypeListingViewmodel extends IBaseModel {
  key?: string;
  name?: string;
  type?: string;
  icon_class?: string;
  acceptedType?: string;
}
export class DocumentTypeListingViewmodel extends BaseModel implements IDocumentTypeListingViewmodel {
  key?: string;
  name?: string;
  type?: string;
  icon_class?: string;
  acceptedType?: string;
  /**
   *
   */
  constructor(partial: Partial<IDocumentTypeListingViewmodel>) {
    super(partial);
  }
}


// WEBPACK FOOTER //
// ./src/models/documents/document-type-listing.viewmodel.ts